import styled from '@emotion/styled';
import { Typography } from '@mgmresorts/mgm-ui';

export const StyledContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;

export const StyledHintContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const StyledPasswordHint = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  column-gap: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXs}px;
  display: flex;
  align-items: center;

  &.hint-success {
    color: ${({ theme }) => theme.semantic.SuccessDefault};

    path {
      fill: ${({ theme }) => theme.semantic.SuccessDefault};
    }
  }

  &.hint-error {
    color: ${({ theme }) => theme.semantic.ErrorDefault};

    path {
      fill: ${({ theme }) => theme.semantic.ErrorDefault};
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
export const StyledPasswordHintList = styled.ul`
  margin: ${({ theme }) => theme.semantic.SpaceComponentNone}px;
  padding-left: ${({ theme }) => theme.semantic.BorderWidthFocused}rem;
  list-style-type: disc;
  list-style-position: outside;
`;

export const StyledPasswordHintItem = styled.li`
  margin-bottom: ${({ theme }) => theme.semantic.BorderWidthSubtle}rem;
  color: ${({ theme }) => theme.semantic.FgDefault};
`;

export const StyledPasswordHintText = styled(StyledPasswordHint)`
  display: inline;
`;
